import { PORT, PROTOCOL } from '@constants';

export const makeBaseUrl = (domain: string) =>
  `${PROTOCOL}://${domain}:${PORT}/api`;
